/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */

/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';
import { token } from '@atlaskit/tokens';
import { Box } from '@atlaskit/primitives/compiled';

import {
	useExperienceRenderAndMountMark,
	ExperienceMark,
} from '../../common/utils/experience-tracker';
import Skeleton from './skeleton';

const iconSkeleton = (
	<Box
		style={{
			display: 'inline-block',
			width: 32,
			height: 32,
			backgroundColor: token('color.skeleton'),
			borderRadius: token('border.radius.200'),
		}}
	/>
);

const orgs = (
	<Box
		aria-hidden="true"
		style={{
			display: 'flex',
			paddingInline: token('space.150'),
			paddingBlock: token('space.100'),
			alignItems: 'center',
		}}
	>
		{iconSkeleton}
	</Box>
);

export default () => {
	useExperienceRenderAndMountMark(ExperienceMark.SWITCHER_SKELETON_MOUNT);
	return (
		<Box
			style={{
				display: 'flex',
				flexDirection: 'row',
				gap: token('space.100'),
				height: '80vh',
				position: 'relative',
			}}
			testId="skeleton-with-orgs"
		>
			<Box
				aria-hidden="true"
				style={{
					width: '56px',
					height: '100%',
					paddingTop: token('space.300'),
					borderRight: `2px solid ${token('color.skeleton')}`,
					alignItems: 'center',
				}}
			>
				{orgs}
				{orgs}
				{orgs}
			</Box>
			<Skeleton />
		</Box>
	);
};
